var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThIconMenuCollapse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 22.5H22V2.5H20V11.5H5.83L11.33 6L9.92 4.58L2 12.5L9.92 20.42L11.33 19L5.83 13.5H20V22.5Z",
    fill: "#97E0BC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThIconMenuCollapse);
export default __webpack_public_path__ + "static/media/TH-Icon-Menu-Collapse.74c1620b0610049a339bee5e49c36854.svg";
export { ForwardRef as ReactComponent };